import * as React from "react"
import { type DigitsLocation } from "@digits-shared/components/Router/DigitsLocation"
import useRouter from "@digits-shared/hooks/useRouter"
import routes from "src/frontend/routes"

function useRedirectToOnboarding() {
  const { location } = useRouter()

  const fromLocation = location.state?.from as DigitsLocation
  if (
    routes.welcome.isCurrentParentLocation(location) ||
    routes.onboard.isCurrentParentLocation(location) ||
    !fromLocation?.queryParams
  ) {
    return
  }

  const { t } = fromLocation.queryParams
  if (!t) return

  const path = routes.welcome.generateFromCurrentPath({ t })
  const newLocation: DigitsLocation = {
    ...fromLocation,
    queryParams: { ...fromLocation.queryParams },
  }
  delete newLocation.queryParams.t

  const state = { from: newLocation }
  return { path, state }
}

export function useOnboardingRedirect() {
  const { history } = useRouter()
  const redirectToOnboarding = useRedirectToOnboarding()

  React.useEffect(() => {
    if (redirectToOnboarding) {
      const { path, state } = redirectToOnboarding
      // weird bug when using LocationDescriptor with <Redirect/> or even history.replace(location)
      // where after going to onboarding, react-router would redirect back to /login.
      // using replace(path, state) solves this.
      history.replace(path, state)
    }
  }, [history, redirectToOnboarding])

  return React.useMemo(
    () => ({
      redirectToOnboarding,
    }),
    [redirectToOnboarding]
  )
}
